import { jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import axios from "axios";
const Context = React.createContext({
  shiftPlanner: null,
  echoCore: null,
  patient: null,
  calmaster: null
});
const AxiosProvider = ({
  children,
  auth,
  shiftPlannerBaseURL,
  echoCoreBaseURL,
  calmasterBaseURL,
  patientBaseURL
}) => {
  const shiftPlannerInstance = axios.create({
    baseURL: shiftPlannerBaseURL,
    headers: {
      Authorization: auth ?? ""
    }
  });
  const echoCoreInstance = axios.create({
    baseURL: echoCoreBaseURL,
    headers: {
      Authorization: auth ?? ""
    }
  });
  const calmasterInstance = axios.create({
    baseURL: calmasterBaseURL,
    headers: {
      Authorization: auth ?? ""
    }
  });
  const patientInstance = axios.create({
    baseURL: patientBaseURL,
    headers: {
      Authorization: auth ?? ""
    }
  });
  return /* @__PURE__ */ jsx(
    Context.Provider,
    {
      value: {
        shiftPlanner: shiftPlannerInstance,
        echoCore: echoCoreInstance,
        patient: patientInstance,
        calmaster: calmasterInstance
      },
      children
    }
  );
};
const useAxiosProvider = () => {
  const context = useContext(Context);
  if (context === void 0) {
    throw new Error("useAxiosProvider must be used within AxiosProvider.");
  }
  return context;
};
export {
  AxiosProvider,
  Context,
  useAxiosProvider
};
